import { useIsLoggedIn } from '../../../../context/AuthMachine';
import { useOrderStatusHasEarnedLoyaltyPointsQuery } from '../../graphql/OrderStatus.generated';

/**
 * Returns a boolean value for whether the customer has earned loyalty points for this order.
 */
export const useHasEarnedLoyaltyPoints = (
  orderId?: string,
  isOrderCancelled?: boolean,
) => {
  const isLoggedIn = useIsLoggedIn();

  const variables = { id: orderId ?? '' };
  const pause = !isLoggedIn || !orderId || isOrderCancelled;

  const [{ data }] = useOrderStatusHasEarnedLoyaltyPointsQuery({
    pause,
    variables,
  });

  if (data?.orderStatus?.__typename === 'OrderStatus') {
    return data.orderStatus.order.hasEarnedLoyaltyPoints;
  }

  return false;
};
